import L from "leaflet";
import { useEffect, useState } from "react";
import { useMap } from "../../providers/hooks/MapContext";

export default function MeasureControl() {
  const map = useMap();
  const [measureControl, setMeasureControl] = useState(null);

  // Set measure control
  useEffect(() => {
    if (map && !measureControl) {
      const control = new L.Control.Measure({
        position: "topleft",
        primaryLengthUnit: "meters",
        secondaryLengthUnit: "kilometers",
        primaryAreaUnit: "sqmeters",
        secondaryAreaUnit: "hectares",
        localization: "pt_BR",
        activeColor: "#b83d22",
        completedColor: "#b83e00",
      }).addTo(map);

      map.on("measurefinish", () => {
        const printButton = document.createElement("button");
        printButton.title = "Imprimir medidas";
        printButton.classList.add("print-measures");
        printButton.innerHTML = "🖨 Imprimir";
        printButton.onclick = window.printMeasures;
        document.getElementsByClassName("tasks");
        const li = document.createElement("li");
        li.appendChild(printButton);
        setTimeout(() => {
          document
            .getElementsByClassName("leaflet-popup-content")[0]
            .children[0].children[3].appendChild(li);
        }, 1000);
      });

      setMeasureControl(control);
    }
  }, [map, measureControl]);

  return <></>;
}
